/**
 * @file
 * Scroll Tracker
 * appends a scroll-tracker custom CSS rule to use within stylesheet
 * use to CSS transition any element.
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ComponentBase from '../core/component-base';

gsap.registerPlugin(ScrollTrigger);

export default class ScrollTracker extends ComponentBase {
  constructor(options = {}) {
    super('scrollTracker');

    /**
     *
     * @property {String} scrollTrackerItem
     *   pass in an item to track.
     *   Defaults to '.scroll-tracker__item'.
     *
     * @property {strink} trackingUnit
     *   append a unit value to the end of the scrollTracking value IE: 'px', 'deg', '%'
     *   Defaults to an empty string
     *
     * @property {bool} directionReverse
     *   Set values to count backwards starting from its max possible value
     *   Defaults to false
     */

    this.options = {
      ...{
        scrollTrackerItem: '.scroll-tracker__item',
        directionReverse: false,
        trackingUnit: '',
      },
      ...options,
    };
  }

  init() {
    this.items.forEach(item => {
      document.addEventListener('DOMContentLoaded', () => {
        const valueTarget = item.querySelector(item.scrollTrackerItem);
        ScrollTrigger.create({
          trigger: item,
          start: `-=${window.innerHeight}px`,
          end: 'bottom',
          onToggle: self => {
            // Set an attribute on the target that determines if its tracking
            const isTracking = self.isActive == true;
            valueTarget.setAttribute('data-is-tracking', isTracking);
          },
          onUpdate: self => {
            // Add the scroll direction as an attribute on the target
            const scrollDirection = self.direction == 1 ? 'down' : 'up';
            if (
              scrollDirection !=
              valueTarget.getAttribute('data-scroll-direction')
            ) {
              valueTarget.setAttribute(
                'data-scroll-direction',
                scrollDirection,
              );
            }

            // If reverseProgress is true, we count down from the ending number, otherwise count up
            const reverseProgress =
              window.innerHeight +
              item.offsetHeight -
              (window.innerHeight +
                item.offsetHeight * self.progress.toFixed(3));
            if (item.directionReverse == true) {
              valueTarget.setAttribute(
                'style',
                `--scroll-tracker:${reverseProgress}${item.trackingUnit}`,
              );
            } else {
              valueTarget.setAttribute(
                'style',
                `--scroll-tracker:${self.progress.toFixed(3)}${
                  item.trackingUnit
                }`,
              );
            }
          },
        });
      });
    });
  }
}
